export const ADMIN_VISITOR_PATCH_STORAGE_KEY = "admin_visitor_event_patch_v1";

type Row = Record<string, unknown>;

/** 予定管理の URL クエリからフォームへ渡すキー（ホワイトリスト） */
export const ADMIN_EVENT_PREFILL_PARAM_KEYS = [
  "event_name",
  "event_date",
  "venue",
  "prefecture",
  "detail_url",
  "reserve_url",
  "description",
  "memo",
  "performance_text",
  "reception_period_text",
  "source",
  "visibility",
  "event_kind",
  "status",
  "time_start",
  "time_end",
  "door_time",
  "curtain_time",
  "door_time_2",
  "curtain_time_2",
  "door_time_3",
  "curtain_time_3",
  "homepage_public_date",
  "homepage_public_at",
  "reception_start",
  "reception_end",
  "group_code",
  "karin_subtype",
  "karin_icon",
  "performers",
  "is_karin",
] as const;

export type AdminEventPrefillParamKey = (typeof ADMIN_EVENT_PREFILL_PARAM_KEYS)[number];

export function inferAdminModeForRow(r: Row): string {
  if (Number(r.is_karin)) return "karin";
  const src = String(r.source ?? "").trim();
  if (src === "fan_post") {
    if (String(r.fan_group_name ?? "").trim()) return "helloproject";
    if (String(r.fan_artist_name ?? "").trim()) return "jp_room";
  }
  if (src === "helloproject") return "helloproject";
  if (src === "mline") return "mline";
  if (src === "jp_room") return "jp_room";
  return "karin";
}

/** 自動取得ログの source 文字列から予定管理タブを推測 */
export function inferAdminModeFromIngestSource(source: string): string {
  const s = source.toLowerCase();
  if (s.includes("helloproject") || s.includes("ハロプロ")) return "helloproject";
  if (s.includes("mline") && !s.includes("jp")) return "mline";
  if (s.includes("jp_room") || s.includes("jp-room") || s.includes("j.p")) return "jp_room";
  return "karin";
}

export function mergePrefillFromSearchParams(base: Row, params: URLSearchParams): Row {
  const next: Row = { ...base };
  for (const k of ADMIN_EVENT_PREFILL_PARAM_KEYS) {
    if (k === "performers") continue;
    if (k === "is_karin") {
      const v = params.get(k);
      if (v === "0" || v === "1") next.is_karin = Number(v) as 0 | 1;
      continue;
    }
    const v = params.get(k);
    if (v == null) continue;
    const trimmed = v.trim();
    if (!trimmed) continue;
    next[k] = trimmed;
  }
  return next;
}

export function performersParamToComma(params: URLSearchParams): string | null {
  const raw = params.get("performers");
  if (raw == null) return null;
  const t = raw.trim();
  if (!t) return "";
  try {
    const j = JSON.parse(t) as unknown;
    if (Array.isArray(j)) return j.map(String).filter(Boolean).join(", ");
  } catch {
    /* fallthrough */
  }
  return t;
}

export function stripAdminEventPrefillKeys(prev: URLSearchParams): URLSearchParams {
  const n = new URLSearchParams(prev);
  n.delete("new");
  n.delete("prefill");
  n.delete("edit");
  for (const k of ADMIN_EVENT_PREFILL_PARAM_KEYS) n.delete(k);
  n.delete("is_karin");
  return n;
}

/** 予定管理「新規」フォームを開く URL（クエリは UTF-8。長すぎる値は切り詰め） */
export function buildAdminNewEventHref(
  mode: string,
  fields: Partial<Record<AdminEventPrefillParamKey | "is_karin", string>>,
): string {
  const p = new URLSearchParams();
  p.set("new", "1");
  const maxLen = 1200;
  for (const [key, val] of Object.entries(fields)) {
    if (val == null) continue;
    const s = String(val).trim();
    if (!s) continue;
    p.set(key, s.slice(0, maxLen));
  }
  return `/admin/events/${encodeURIComponent(mode)}?${p.toString()}`;
}
